document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('cascade:modalcart:afteradditem', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );
        });

        window.addEventListener('cascade:modalcart:cartqtychange', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections['cart-items']
            ).outerHTML
          );

          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
          }, 1000);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      // CS-68 (2026-08-16). `this.locked` was a single flag for the WHOLE cart and the guard was
      // `if (this.locked) return`, so while any one line's request was in flight EVERY other Remove
      // or quantity click was silently discarded: no error, no retry, no feedback. Reproduced on the
      // live store: two Remove clicks 300ms apart on a two-item cart left one item behind. The
      // serialisation the lock provides is correct and is kept; only the DROP becomes a QUEUE, so a
      // click can never be lost. `this.locked` is now the tail of a promise chain, not a boolean.
      itemQuantityChange(key, value) {
        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const clickKey = key ? key : lineItemEl.getAttribute('data-cart-item-key');
        const quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);
        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity === lastValue) return;

        lineItemEl.classList.add('opacity-50', 'cursor-progress');

        const run = () =>
          this._sendQuantityChange(clickKey, quantity, lineItemEl, lastValue);

        // Chain onto whatever is already running. `.catch` on the tail only, so one failed request
        // cannot poison the queue behind it.
        this.locked = Promise.resolve(this.locked).catch(() => {}).then(run);
      },

      _sendQuantityChange(clickKey, quantity, lineItemEl, lastValue) {
        // Re-read the key at SEND time. A queued request may dequeue after the cart has re-rendered,
        // and an app that rewrites line properties (Foxkit's follow-up /cart/update) changes the
        // line key when it does. A detached element still returns its old attribute, which is the
        // click-time key, so this is never worse than the previous behaviour.
        const id = lineItemEl.getAttribute('data-cart-item-key') || clickKey;
        const sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

        const config = fetchConfigDefaults('javascript');

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        return fetch(theme.routes.cart_change_url, config)
          .then((res) => res.json())
          .then((data) => {
            if (data.status === 422) {
              const errorEl = lineItemEl.querySelector(
                '[data-cart-quantity-error]'
              );

              if (errorEl) {
                errorEl.textContent = data.message;
                errorEl.classList.remove('hidden');
              }

              lineItemEl.classList.remove('opacity-50', 'cursor-progress');

              this.$el.value = lastValue;
            } else {
              document.body.dispatchEvent(
                new CustomEvent('cascade:modalcart:cartqtychange', {
                  bubbles: true,
                  detail: { response: data, originalTarget: lineItemEl },
                })
              );
            }
          })
          .catch(() => {
            lineItemEl.classList.remove('opacity-50', 'cursor-progress');
            // B17: the three cart readers all dereference unguarded. Guard the node too.
            const errors = document.getElementById('cart-errors');
            if (errors) errors.textContent = theme.strings.cartError;
          });
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});